import { DateTime } from 'luxon';
import { Collaborator } from '../collaborators/Collaborator';
import SystemDocumentType from './SystemDocumentType';
import DocumentUploadControl, { IDocumentControl } from './DocumentUploadControl';
import DocumentUploadControlVisitor from '../projects/DocumentUploadControlVisitor';
import {
  ProjectConfigurationDocsForm,
  ProjectDocumentControlForm,
} from '../../Components/Proyectos/ProjectConfiguration/ProjectConfigurationDocsForm';
import { ITemporality } from '../temporality/TemporalitySystem';

class DocumentUploadControlPending implements DocumentUploadControl {
  constructor(
      private documentType: SystemDocumentType,
      private responsible: Collaborator,
      private concept: string,
      private limitDate: DateTime,
      private fromDate?: DateTime,
      private temporality?: ITemporality
  ) {}

  accept(visitor: DocumentUploadControlVisitor<any>) {
    return visitor.visitDocumentUploadControlPending(this);
  }

  static from(
      documentType: SystemDocumentType,
      responsible: Collaborator,
      concept: string,
      limitDate: DateTime,
      fromDate?: DateTime,
      temporality?: ITemporality
  ) {
    return new this(documentType, responsible, concept, limitDate, fromDate, temporality);
  }

  toIDocumentControl(): IDocumentControl {
    return {
      ccdp_doctid: this.documentType.getId(),
      ccdp_fecha_limite: String(this.limitDate.toUTC().toISODate()),
      ccdp_responsable_provisorio: this.responsible.getId(),
      ccdp_concepto: this.concept,
      ccdp_dictemp_id: this.temporality ? this.temporality.dictemp_id : undefined,
    };
  }

  getDocumentType(): SystemDocumentType {
    return this.documentType;
  }

  getCollaborator(): Collaborator {
    return this.responsible;
  }

  getConcept(): string {
    return this.concept;
  }

  getLimitDate(): DateTime {
    return this.limitDate;
  }

  isUploaded(): boolean {
    return false;
  }
  isExpired(): boolean {
    return this.getLimitDate().diffNow().days > 0;
  }
  syncWith(doc: DocumentUploadControl): this {
    this.documentType = doc.getDocumentType();
    this.responsible = doc.getCollaborator();
    this.concept = doc.getConcept();
    this.limitDate = doc.getLimitDate();
    this.fromDate = doc.getFromDate();
    this.temporality = doc.getTemporality();
    return this;
  }

  getFromDate() {
    return this.fromDate;
  } 

  getTemporality() {
    return this.temporality;
  }
}

export default DocumentUploadControlPending;
